import { createRequestErrorFromResponse } from './common-errors';
export function defaultStatusCodeCheck(response) {
    const statusCode = response.status;
    if ((statusCode >= 200 && statusCode < 300) || statusCode === 302 || statusCode === 304) {
        return response;
    }
    else {
        throw createRequestErrorFromResponse(response, response.requestURL);
    }
}
//# sourceMappingURL=status-code-check.js.map